import { jsx as l } from "react/jsx-runtime";
const a = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M2 11.7C2 6.126 6.367 2 12 2s10 4.126 10 9.7-4.367 9.7-10 9.7c-1.012 0-1.983-.134-2.895-.384a.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.122-.707l-.055-1.78a.8.8 0 0 0-.268-.57C3.195 17.135 2 14.616 2 11.7m6.933-1.824-2.938 4.66c-.282.448.268.952.689.632l3.155-2.394a.6.6 0 0 1 .723-.002l2.337 1.752a1.5 1.5 0 0 0 2.169-.4l2.937-4.66c.282-.448-.268-.952-.689-.632l-3.155 2.394a.6.6 0 0 1-.723.002L11.1 9.476a1.5 1.5 0 0 0-2.168.4",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  a as default
};
